import React from "react";
import "./style.css";
const Input = (props) => {
  return (
    <div className="input-wrap">
      {props.label && <label>{props.label}</label>}
      <input
        placeholder={props.placeholder}
        onChange={
          props?.onChange ? props?.onChange : props?.formik?.handleChange
        }
        name={props?.name}
        type={props?.type ? props?.type : "text"}
      />
      {props?.formik?.errors?.[props.name] &&
        props?.formik?.touched?.[props.name] && (
          <div className="error-text mtHalf">{props?.formik?.errors?.[props.name]}</div>
        )}
    </div>
  );
};

export default Input;
